import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ children }) => {
  const isAdmin = localStorage.getItem('isAdmin') === 'true';
  const adminEmail = localStorage.getItem('adminEmail');

  if (!isAdmin || !adminEmail) {
    return <Navigate to="/manage/login" replace />;
  }

  return children;
};

export default AdminRoute;